import { DNA } from '../visual-language'

export function separatorStyles({
  thickness = 'default',
  orientation = 'horizontal',
}: SeparatorStylesProps = {}) {
  let thicknessToken = DNA.tokens.alias.dimension.borderSize[thickness]

  return {
    backgroundColor: DNA.tokens.color.grey[800],
    borderRadius: DNA.tokens.alias.dimension.borderRadius.default,
    height: orientation === 'vertical' ? '100%' : thicknessToken,
    width: orientation === 'vertical' ? thicknessToken : '100%',
  }
}

export interface SeparatorStylesProps {
  /** Changes the thickness of the separator. */
  thickness?: 'default' | 'thin' | 'thick' | 'thicker' | 'thickest'
  /** Orientation of the sepaator */
  orientation?: 'horizontal' | 'vertical'
}
